<!-- Evaluation COMMENTS component -->

<template>
  <div>
    <v-btn :disabled="state == 'LOADING'" class="exit-icon red-background" dark small @click="onCloseRX"
      >Close Rx-Preview</v-btn
    >
    <v-btn :disabled="state == 'LOADING'" class="genrpt" dark small @click="onPrint">Send Rx-Report</v-btn>&nbsp;
    <v-btn :disabled="state == 'LOADING'" class="download-button" dark small @click="onDownload"
      >Download Rx-Report</v-btn
    >&nbsp;

    <md-card id="rptpreview" class="md-with-hover" style="margin: 20px; padding: 20px">
      <!-- <md-icon class="exit-icon">close</md-icon> -->
      <md-card-content>
        <!-- PDF REPORT (START) -->
        <div id="pdf" style="margin: 5px">
          <article id="heading">
            <section style="visibility: hidden">
              <span>{{ getOrgName }}</span> <br />
              <span>{{ getOrgPhone }}</span> <br />
              <span>{{ getOrgDomain }}</span>
            </section>
            <section class="gclogo">
              <img id="gclogo" src="@/assets/img/GlobeChek2.png" alt="GlobeChek" class="img-responsive" />
            </section>
            <section>
              <span>{{ getOrgName }}</span> <br />
              <span>{{ getOrgPhone }}</span> <br />
              <span>{{ getOrgDomain }}</span>
            </section>
          </article>

          <br />
          <hr style="height: 3px; margin-top: 10px; margin-bottom: 10px; background-color: #275" />

          <article id="member">
            <section>
              <h4>&nbsp;</h4>
              <dl id="info-screen">
                <dt class="mtitle">PATIENT</dt>
                <dd>&nbsp;&nbsp; {{ eval.patientInfo.firstName }}&nbsp;{{ eval.patientInfo.lastName }}</dd>
                <br />
                <dt class="mtitle">DOB</dt>
                <dd>
                  &nbsp;&nbsp;
                  {{ getDob }}
                </dd>
                <dt class="mtitle">ADDRESS</dt>
                <dd>
                  &nbsp;&nbsp;
                  {{ eval.patientInfo.address.addressLn1 }}
                  {{ eval.patientInfo.address.addressLn2 }}
                  {{ eval.patientInfo.address.city }} &nbsp; {{ eval.patientInfo.address.state }} &nbsp;
                  {{ eval.patientInfo.address.zip }} &nbsp;
                </dd>
                <dt class="mtitle">HOME PHONE</dt>
                &nbsp;&nbsp;
                <dd>-</dd>
                <dt class="mtitle">CELL PHONE</dt>
                &nbsp;&nbsp;
                <dd>{{ eval.patientInfo.phone }}</dd>
              </dl>
            </section>
            <section>
              <h4><b>{{ title }} PRESCRIPTION</b></h4>
              <br />
              <dl id="info-address">
                <dt class="mtitle">ENCOUNTER DATE</dt>
                &nbsp;&nbsp;
                <dd>{{ getScreenDate }}</dd>
                <br />
                <dt class="mtitle">PROVIDER</dt>
                &nbsp;&nbsp;
                <dd>
                  {{ getReadingDoctor }}
                </dd>
              </dl>
            </section>
          </article>

          <br />
          <hr style="height: 2px; margin-top: 10px; margin-bottom: 25px; background-color: #275" />
          <article v-if="title == 'GLASSES'" id="screening" style="line-height: 1.75rem">
            <div id="pdf-content" style=" overflow-x: hidden;">
            <table :style="screeningTable" class="screening-table">
              <thead>
                <tr>
                  <th :style="cellStyle"></th>
                  <th :style="cellStyle">SPHERE</th>
                  <th :style="cellStyle">CYLINDER</th>
                  <th :style="cellStyle">AXIS</th>
                  <th :style="cellStyle">ADD</th>
                  <th :style="cellStyle">VA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th :style="cellStyle" class="heading">Right</th>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odSPH) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odCYL) }}</b></td>
                  <td :style="cellStyle">
                    <b>{{ rxValues.odAXS }}<span v-if="rxValues.odAXS != null && rxValues.odAXS > 0">&deg;</span></b>
                  </td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odPOW) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatAcuity(rxValues.odDIS) }}</b></td>
                </tr>
                <tr>
                  <th :style="cellStyle" class="heading">Left</th>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osSPH) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osCYL) }}</b></td>
                  <td :style="cellStyle">
                    <b>{{ rxValues.osAXS }}<span v-if="rxValues.osAXS != null && rxValues.osAXS > 0">&deg;</span></b>
                  </td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osPOW) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatAcuity(rxValues.osDIS) }}</b></td>
                </tr>
              </tbody>
            </table>
            </div>
          </article>

          <article v-if="title == 'CONTACT'" id="screening" style="line-height: 1.75rem">
            <div id="pdf-content" class="scroll-container" >
            <table :style="screeningTableContact" class="screening-table-contact">
              <thead>
                <tr>
                  <th :style="cellStyle"></th>
                  <th :style="cellStyle">SPHERE</th>
                  <th :style="cellStyle">CYLINDER</th>
                  <th :style="cellStyle">AXIS</th>
                  <th :style="cellStyle">ADD</th>
                  <th :style="cellStyle">VA</th>
                  <th :style="cellStyle">BASE CURVE</th>
                  <th :style="cellStyle">DIAMETER</th>
                  <th :style="cellStyle">BRAND</th>
                  <th :style="cellStyle">MANUFACTURER</th>
                  <th :style="cellStyle">COLOR/MF PWR</th>
                  <th :style="cellStyle">QTY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th :style="cellStyle" class="heading">Right</th>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odSPH) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odCYL) }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odAXS }}<span v-if="rxValues.odAXS != null && rxValues.odAXS > 0">&deg;</span></b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.odPOW) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatAcuity(rxValues.odDIS) }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odBC }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odDIA }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odBRA }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odMAN }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odCOL }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.odQT }}</b></td>
                </tr>
                <tr>
                  <th :style="cellStyle" class="heading">Left</th>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osSPH) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osCYL) }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osAXS }}<span v-if="rxValues.osAXS != null && rxValues.osAXS > 0">&deg;</span></b></td>
                  <td :style="cellStyle"><b>{{ formatSigned(rxValues.osPOW) }}</b></td>
                  <td :style="cellStyle"><b>{{ formatAcuity(rxValues.osDIS) }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osBC }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osDIA }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osBRA }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osMAN }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osCOL }}</b></td>
                  <td :style="cellStyle"><b>{{ rxValues.osQT }}</b></td>
                </tr>
              </tbody>
            </table>
            </div>
          </article>

          <dl align="left" style="margin-top: 1rem">
            <dt colspan="5" style="font-size: 1rem; font-weight: 700; ">Comments:</dt>
            <dt colspan="5">{{ rxValues.ouCOM }}</dt>
            <dt class="spacer rl-top" style="font-size: 0.9rem">&nbsp;</dt>
          </dl>

          <hr style="height: 2px; margin-top: 250px; margin-bottom: 20px; background-color: #275" />

          <article id="member" style="line-height: 1.8rem">
            <section>
              <dl id="info-screen">
                <dt class="mtitle"><b>Electronic Signature</b></dt>
                <dd></dd>
                <dt class="mtitle">&nbsp;&nbsp;&nbsp;Medical services perfomed by</dt>
                <dd>{{ getServiceProvider }}</dd>
                <dt class="mtitle">&nbsp;&nbsp;&nbsp;Electronically signed by</dt>
                <dd>
                  <strong>
                    <i>{{ getReadingDoctor }}</i>
                  </strong>
                </dd>
                <dt style="padding-top: 25px">* Valid for one year</dt>
                <dd>{{ validDateRange }}</dd>
              </dl>
            </section>
          </article>

          <hr style="height: 2px; margin-top: 20px; margin-bottom: 5px; background-color: #275" />
        </div>
        <!-- PDF REPORT (END) -->
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import Swal from "sweetalert2"
import moment from "moment"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "RxPreview", // => ReportPreview
  components: {},
  props: ["viewonly", "rxValues", "title"],
  data() {
    return {
      state: "",
      status: "",
      branding: false,
      API_SERVICE: process.env.VUE_APP_URL,
      PREREG_API: process.env.VUE_APP_PREREG,
      APP_HOST: process.env.VUE_APP_HOST,
      APP_EMAIL_HOST: process.env.VUE_APP_EMAIL_HOST,
      token: process.env.VUE_APP_TOKEN,
      creds: null,
      cellStyle: {
        border: '1px solid #ccc',
        padding: '0.5rem',
        textAlign: 'center',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        wordBreak: 'break-word'
      },

      screeningTableContact: {
        width: 'max-content',
        maxWidth: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        fontSize: '0.75rem',
      },
      screeningTable: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        fontSize: '0.75rem'
      }
    }
  },
  computed: {
    ...mapGetters(["eval", "screeningID"]),
    validDateRange() {
      const today = new Date()
      const nextYear = new Date()
      nextYear.setFullYear(today.getFullYear() + 1)

      const options = { year: "numeric", month: "long", day: "numeric" }

      const start = today.toLocaleDateString(undefined, options)
      const end = nextYear.toLocaleDateString(undefined, options)

      return `${start} - ${end}`
    },
    getReadingDoctor() {
      const evalUser = this.eval && this.eval.lastUpdateByUser
      const evalUserType = evalUser ? evalUser.userType : null
      const evalUserName = evalUser ? evalUser.name : null
    
      const sessionUserType = sessionStorage.getItem("usertype")
      const sessionUser = sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    
      if (evalUser && evalUserType !== "Technician" && evalUserType !== "Admin") {
        return evalUserName
      }
    
      if (sessionUserType !== "Technician" && sessionUserType !== "Admin") {
        return sessionUser
      }
    
      return ""
    },
    getServiceProvider() {
      return sessionStorage.getItem("OrgBusiness")
    },
    getOrgName() {
      return JSON.parse(localStorage.getItem("currentOrg")).businessName
    },
    getOrgPhone() {
      // this is not a required field so we validate it
      const phone = JSON.parse(localStorage.getItem("currentOrg")).contactPhone
      return phone ? phone : ""
    },
    getOrgDomain() {
      // this is not a required field so we validate it
      const domain = JSON.parse(localStorage.getItem("currentOrg")).domain
      return domain ? domain : ""
    },
    getDob: function () {
      //return moment(this.eval.patientInfo.dob, "MM/DD/YYYY").format("l");
      return moment(this.eval.patientInfo.dob, "YYYY-MM-DD").format("l")
    },
    applyBranding() {
      return this.branding
    },
    getAge: function () {
      return moment().diff(this.eval.patientInfo.dob, "years", false)
    },
    getScreenDate: function () {
      return moment(this.eval.screeningInfo.screeningDate).format("dddd MMMM Do, YYYY")
    },

    viOD() {
      return this.eval.visionInfo.autoRefractionOD
    },
    viOS() {
      return this.eval.visionInfo.autoRefractionOS
    },
    OD_Sph() {
      if (this.viOD) {
        var ods = this.viOD.slice(0, this.viOD.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OD_Cyl() {
      if (this.viOD) {
        var odc = this.viOD.slice(this.viOD.indexOf(" "), this.viOD.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OD_Axis() {
      if (this.viOD) {
        var oda = this.viOD.slice(this.viOD.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },
    OS_Sph() {
      if (this.viOS) {
        var ods = this.viOS.slice(0, this.viOS.indexOf(" "))
        return ods
      } else {
        return "n/a"
      }
    },
    OS_Cyl() {
      if (this.viOS) {
        var odc = this.viOS.slice(this.viOS.indexOf(" "), this.viOS.indexOf("x"))
        return odc
      } else {
        return "n/a"
      }
    },
    OS_Axis() {
      if (this.viOS) {
        var oda = this.viOS.slice(this.viOS.indexOf("x") + 1)
        return oda
      } else {
        return "n/a"
      }
    },
    OD_Angle() {
      return this.eval.visionInfo.angleMeasurementOD
    },
    OS_Angle() {
      return this.eval.visionInfo.angleMeasurementOS
    },
    colorOD() {
      if (this.eval.visionInfo.visionComments) {
        var colR = this.eval.visionInfo.visionComments.split("|")[0]
        return colR
      }
    }
  },
  methods: {
    ...mapActions(["generateHtmlReport", "generatePdfReport", "getSignedReport"]),
    replaceChar(origString, replaceChar, index) {
      var newStringArray = origString.split("")
      newStringArray[index] = replaceChar
      var newString = newStringArray.join("")
      return newString
    },

    onCloseRX() {
      this.$emit("onCloseRX")
    },
    async checkIfFileExists(url) {
      try {
        const response = await fetch(url, { method: "HEAD" })
        return response.ok
      } catch (err) {
        console.error("Error checking file:", err)
        return false
      }
    },
    async onDownload() {
      this.state = "LOADING"
      try {
        const reportId = sessionStorage.getItem("storageID")
        let response = await this.getSignedReport({ reportId: `${reportId}-rx` })
        let signedURL = response.signedUrl
        // const fileExists = await this.checkIfFileExists(signedURL)
        // if (!fileExists) {
          await this.generateHtmlReport({ isRxReport: true })
          await this.generatePdfReport({
            reportId: `${reportId}-rx`
          })
          response = await this.getSignedReport({ reportId: `${reportId}-rx` })
          signedURL = response.signedUrl
        // }
        const link = document.createElement("a")
        link.href = signedURL
        link.download = `RxReport-${reportId}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "An error occurred while downloading the report: " + error,
          confirmButtonText: "OK"
        })
      }
      this.state = "FINISHED"
    },
    async onPrint() {
      this.state = "LOADING"
      try {
        const reportId = sessionStorage.getItem("storageID")
        const payload = {
          reportId: `${reportId}-rx`,
          email: this.eval.patientInfo.email,
          firstName: this.eval.patientInfo.firstName
        }
        await this.generateHtmlReport({ isRxReport: true })
        await this.generatePdfReport(payload)
        Swal.fire({
          title: "Success",
          text: "RX Report Registered! - Notifications sent to patient",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          if (this.viewonly == "True") {
            return
          }
          this.$emit("onCloseRX")
        })
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "An error occurred while generating the report: " + error,
          confirmButtonText: "OK"
        })
      } finally {
        this.state = "FINISHED"
      }
    },

    generateReport: function () {
      //console.log("Generating report...");
      //debugger;

      //GET User Credentials
      var vm = this
      var _screeningID = vm.screeningID
      var _readerID = sessionStorage.getItem("userID")
      var _readerEmail = sessionStorage.getItem("username")
      var _readerName = sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
      var _patientUserID = sessionStorage.getItem("patientUserID")
      var _patientEmail = vm.eval.patientInfo.email
      var _patientName = vm.eval.patientInfo.firstName + " " + vm.eval.patientInfo.lastName
      var _tmpPswd = "user not found"

      const config = { headers: { "Content-Type": "application/json" } }
      //const url = vm.API_SERVICE + "/creds/" + vm.eval.patientInfo.email;
      const url = vm.API_SERVICE + "/user/creds/" + _patientEmail
      const data = {}

      window.axios.put(url, data, config).then((response) => {
        _tmpPswd = response.data[0]

        //ADD:      reports_generated entry
        vm.status = "Generating Screening Report . . . ."
        const config_A = { headers: { "Content-Type": "application/json" } }
        const url_A = vm.API_SERVICE + "/report/generate/"
        const data_A = {
          screeningID: sessionStorage.getItem("storageID"),
          orgID: sessionStorage.getItem("OrgID"),
          generatedby: sessionStorage.getItem("userID"),
          rptType: "PDF",
          status: "unread",
          createdBy: sessionStorage.getItem("userID")
        }

        //console.log("generateReport:POST " + url_A);
        window.axios.post(url_A, data_A, config_A).then(function (response) {
          vm.status = response.data

          //UPDATE:   screenings_avaialable STATUS to "PROCESSED"
          vm.status = "Updating Screening Status . . . ."
          var _msgBody = `
                  <html><body>
                  <H3>Your GlobeChek report is ready.</h3>
                  <br>
                  <p>Please login to the GlobeChek Portal to review your GlobeChek report. </p>
                  <p>Sign in <b><a href="${vm.APP_EMAIL_HOST}">HERE.<a/></b></P>
                  <br><p>Your temporary password is: &nbsp; <i> ${_tmpPswd} </i>
                  <br><br>
                  </body></html>
                  `
          const config_B = { headers: { "Content-Type": "application/json" } }
          const url_B = vm.API_SERVICE + "/screening/" + _screeningID + "/Closed" + "/" + _readerID
          const data_B = null

          //console.log("generateReport:PUT " + url_B);
          window.axios.put(url_B, data_B, config_B).then(function (response) {
            vm.status = response.data

            //POST MESSAGE to Member:
            vm.status = "Sending Message to Member . . . ."
            const config_C = {
              headers: { "Content-Type": "application/json" }
            }
            const url_C = vm.API_SERVICE + "/msg/newmessage"
            const data_C = {
              senderID: "Admin@GlobeChek.com",
              senderName: _readerName,
              recipientID: _patientUserID, // vm.eval.patientInfo.email,
              recipientName: vm.eval.patientInfo.firstName + " " + vm.eval.patientInfo.lastName,
              msg_subject: "Your GlobeChek Report is ready.",
              msg_body: _msgBody,
              msg_level: "normal"
            }

            console.log("Send Member Notifitcation:POST " + url_C)
            window.axios.post(url_C, data_C, config_C).then(function (response) {
              vm.status = response.data

              //POST REPORT-READY EMAIL to Member:
              vm.status = "Sending Report-Ready Email to Member...."
              const config_D = {
                headers: { "Content-Type": "application/json" }
              }
              const url_D = vm.API_SERVICE + "/report-ready"
              const data_D = {
                sender_address: "info@globechek.com",
                recipient_address: _patientEmail,
                recipient_name: _patientName,
                msg_subject: "Your GlobeChek Report is ready . . . ."
              }

              window.axios.post(url_D, data_D, config_D).then(function (response) {
                vm.status = response.data
              })
            })

            // CLEANUP
            try {
              //sessionStorage.removeItem('referrals');
              localStorage.removeItem(vm.screeningID)
            } catch (error) {
              console.log(error)
            }

            //alert('*****************\n  REPORT SUBMITTED!\n***************************');
            vm.showSwal("auto-close")

            // ROUTE to REPORTS LIST
            vm.$router.push(`${sessionStorage.getItem("portalRoute")}/reports`)
          })
        })
      })
    },

    showSwal(type) {
      if (type === "auto-close") {
        Swal.fire({
          //title: "Success!",
          text: "Report Registered! - Notifications sent",
          timer: 1500,
          showConfirmButton: false
        })
      } else if (type === "message-and-cancel") {
        Swal.fire({
          title: "Register this report?",
          text: "Notification will be sent to member to view results.",
          //type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Register it.",
          cancelButtonText: "No, Cancel",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: "Registering . . . .",
              text: "Report is being filed - Member is being notified.",
              //type: "success",
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            }).then((result) => {
              this.generateReport()
            })
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire({
              title: "Cancelled",
              text: "Nothing sent,  ...continuing with evaluaiton.",
              //type: "error",
              confirmButtonClass: "md-button md-info",
              buttonsStyling: false
            }).then(() => {
              return
            })
          }
        })
      }
    },
    formatSigned(val) {
      const num = parseFloat(val);
      if (isNaN(num)) return val;
      return num > 0 ? `+${num}` : `${num}`;
    },

    formatAcuity(val) {
      if (val && val.toString().trim() !== "") {
        return `20/${val}`
      }
      return ""
    }
  }
}
</script>

<style lang="css" scoped>
.md-card {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.swal2-container {
  z-index: 2000 !important;
}

@import url("https://fonts.googleapis.com/css?family=Roboto|Source+Sans+Pro:400,700");

@page {
  size: 8.5in 11in;
  margin: 0.4in 0.4in 0.4in 0.4in;

  @bottom-left {
    color: #1e5de4;
    font-family: Roboto;
    font-size: 0.7rem;
    font-style: italic;
    content: "What we see may save your sight!";
  }

  @bottom-right {
    color: #a9a;
    font-family: Roboto;
    font-size: 0.75rem;
    content: "info@globechek.com | 1-877-GlobeChek | www.GlobeChek.com";
  }
}

@media print {
  nav {
    display: none;
  }

  h1 {
    page-break-before: auto;
    break-before: auto;
  }

  h2 {
    page-break-before: auto;
    break-before: auto;
  }
}

.gclogo {
  background: url("rptAssets/img/GlobeChek2.png") no-repeat;
  background-size: 140px 80px;
  width: 200px;
  height: 80px;
}

.gclogo img {
  display: none;
}

html {
  color: #14213d;
  font-family: Roboto;
  font-size: 0.8rem;
  /* line-height: 1.6; */
}

html body {
  margin: 0;
}

html h1 {
  color: #1e5de4;
  font-family: Roboto;
  font-size: 40pt;
  margin: 0;
}

html hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #555;
  /* old IE */
  background-color: #555;
  /* Modern Browsers */
}

html body article#heading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.8rem;
  line-height: 0.95rem;
}

html body article#heading section span {
  font-size: 0.8rem;
  font-weight: 400;

  margin: 0 5px 0 0;
  /* T R B L */
  padding: 0;
  text-align: left;
}

html body article#member {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.8rem;
  line-height: 1.2rem;
}

html body article#member section dl {
  text-align: left;
}

html body article#member section dl dt,
section dl dd {
  color: rgb(153, 159, 170);
  display: inline;
  margin: 0;
}

html body article#member section dl dt {
  color: rgb(38, 41, 46);
}

html body article#member section dl dt::before {
  content: "";
  display: block;
}

html body article#member section dl dt::after {
  content: ": ";
}

html body article#screening {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 0.9rem;
  line-height: 1rem;
}

html body article#screening section dl {
  text-align: left;
}

html body article#screening section dl dt,
section dl dd {
  color: rgb(17, 70, 150);
  display: inline;
  margin: 0;
}

html body article#screening section dl dt {
  color: rgb(0, 0, 0);
}

html body article#screening section dl dt::before,
html body article#screening section dl dd {
  content: "";
  display: block;
}

html body article#screening section dl dt::after {
  content: "";
}

html body article#screening section dl dt.subhead {
  font-size: 0.75rem;
  color: rgb(78, 78, 109);
}

html body article#screening section dl dt.title {
  font-size: 0.75rem;
  font-weight: 500;
}

html body article#screening section dl dt.heading {
  font-size: 0.75rem;
  font-weight: 400;
  text-decoration: underline;
}

.spacer {
  margin-bottom: 2px;
}

#imgExt {
  width: 20%;
  height: auto;
}

.rl-top {
  font-size: 0.73rem;
}

.label {
  font-size: 0.88rem;
  font-weight: 600;
}

.field-norm {
  font-size: 0.8rem;
  font-weight: 400;
  margin-top: 6px;
  color: blue;
}

.field-rl {
  font-size: 0.85rem;
  margin: 5px 0px 10px 0px;
  font-weight: 550;
}

.field-top {
  font-size: 0.7rem;
  padding: 0px;
}

.mtitle {
  font-weight: 500;
  font-family: Roboto;
}

.imgdiag {
  line-height: 0.75em;
  font-size: 0.72rem;
  padding: 0px;
  margin-top: 10px;
}

.exit-icon {
  position: sticky;
  top: 15px;
  right: 15px;
  float: right;
  cursor: pointer;
  z-index: 50;
  background-color: red !important;
}

.genrpt {
  position: sticky;
  top: 15px;
  left: 15px;
  float: left;
  cursor: pointer;
  z-index: 50;
  background-color: green !important;
  color: white;
}
.download-button {
  position: sticky;
  top: 15px;
  left: 15px;
  float: left;
  cursor: pointer;
  z-index: 50;
  background-color: #0b6c8d !important;
  color: white;
  margin-left: 15px;
}

::v-deep .rd2 {
  text-align: left;
}

::v-deep .big {
  font-size: 1.5em;
  font-weight: 500;
}

::v-deep .disclaimer {
  text-align: justify;
  text-justify: inter-word;
}


.screening-table th.heading, 
.screening-table-contact th.heading {
  text-align: left;
  font-weight: bold;
  background-color: #f5f5f5;
}
</style>
